import { render, staticRenderFns } from "./MarketingProduct.vue?vue&type=template&id=6365a773&scoped=true"
import script from "./MarketingProduct.vue?vue&type=script&lang=ts"
export * from "./MarketingProduct.vue?vue&type=script&lang=ts"
import style0 from "./MarketingProduct.vue?vue&type=style&index=0&id=6365a773&prod&lang=scss&scoped=true"
import style1 from "./MarketingProduct.vue?vue&type=style&index=1&id=6365a773&prod&lang=scss"
import style2 from "./MarketingProduct.vue?vue&type=style&index=2&id=6365a773&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6365a773",
  null
  
)

export default component.exports